import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useCollectedData } from "shared/contexts/PageData";
import { useViewMode } from "shared/contexts/ViewMode";

import { GridView } from "./GridView";
import styles from "./LayoutWidget012.module.scss";
import { SliderView } from "./SliderView";

export const LayoutWidget012 = ({ payload }) => {
  const { t } = useTranslation();
  const instanceId = buildWidgetInstanceId(
    "l012",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );

  const { articles } = useCollectedData(instanceId, [
    { name: "articles", defaultValue: [] },
  ]);

  const { isMobile } = useViewMode();
  const title = payload?.title ?? "";

  return (
    <div className={styles.wrapper}>
      {isMobile ? (
        <GridView title={t(title)} articles={articles} />
      ) : (
        <SliderView title={t(title)} articles={articles} />
      )}
    </div>
  );
};

export default LayoutWidget012;
